var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeliveryTruck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "-1 -1 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M17.25 5.25A.75.75 0 0 1 18 6v.75h3.242a1.5 1.5 0 0 1 1.345.836l.046.101v.003l1.306 3.263.003.01.004.009.026.072q.003.016.005.032a1 1 0 0 1 .02.1v.015l.003.059v6a1.5 1.5 0 0 1-1.5 1.5h-1.598A3 3 0 0 1 18 21a3 3 0 0 1-2.902-2.25h-4.696a2.998 2.998 0 0 1-5.804 0H3a1.5 1.5 0 0 1-1.5-1.5V6.75A1.5 1.5 0 0 1 3 5.25zM7.5 16.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m10.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M3 14.25v3h1.598a2.998 2.998 0 0 1 5.805 0h4.695a3 3 0 0 1 1.402-1.846V14.25zM18 15c1.398 0 2.569.957 2.902 2.25H22.5V12H18zM3 12.75h13.5v-6H3zm15-2.25h4.143l-.9-2.25H18z",
  clipRule: "evenodd"
})));
export default SvgDeliveryTruck;